<section class="loading" *ngIf="showLoader">
  <p class="loader-message" *ngIf="loaderMsg">{{ loaderMsg }}</p>
  <div class="nt-loading">
    <figure class="loader">
      <img src="assets/images/spinner.svg" alt="Processing..." />
    </figure>
  </div>
</section>
